export enum SystemServerVersionsActionTypes {
    GET_SYSTEM_SERVER_VERSIONS = "[App Action][Halls] GET SYSTEM SERVER VERSIONS",
    GET_SYSTEM_SERVER_VERSIONS_SUCCESS = "[App Action][Halls] GET SYSTEM SERVER VERSIONS SUCCESS",
    GET_SYSTEM_SERVER_VERSIONS_FAIL = "[App Action][Halls] GET SYSTEM SERVER VERSIONS FAIL",
    TOGGLE_SYSTEM_SERVER_VERSION_STATUS = "[App Action][Presets] TOGGLE SYSTEM SERVER VERSION STATUS",
    TOGGLE_SYSTEM_SERVER_VERSION_SUCCESS = "[App Action][Presets] TOGGLE SYSTEM SERVER VERSION STATUS SUCCESS",
    TOGGLE_SYSTEM_SERVER_VERSION_FAIL = "[App Action][Presets] TOGGLE SYSTEM SERVER VERSION STATUS FAIL",
}
